import { formatTokenKey, fromTokens } from "../transform/variables.js";
const createTokens = (tokens, options = {}) => {
  const {
    kebabCase = true,
    target = document.documentElement,
    important = false,
    formatKey = formatTokenKey
  } = options;
  const appliedVariables = /* @__PURE__ */ new Set();
  function processTokens(obj, currentPrefix = "") {
    const cssVars = fromTokens(obj, currentPrefix, {
      kebabCase,
      formatKey
    });
    Object.entries(cssVars).forEach(([varName, value]) => {
      let formattedValue;
      if (Array.isArray(value)) {
        formattedValue = value.join(", ");
      } else if (typeof value === "string") {
        formattedValue = value;
      } else if (value === null || value === void 0) {
        formattedValue = "initial";
      } else {
        formattedValue = String(value);
      }
      if (important) {
        formattedValue += " !important";
      }
      target.style.setProperty(varName, formattedValue);
      appliedVariables.add(varName);
    });
  }
  function updateTokens(newTokens, basePrefix = "") {
    processTokens(newTokens, basePrefix);
  }
  function removeTokens() {
    appliedVariables.forEach((variableName) => {
      target.style.removeProperty(variableName);
    });
    appliedVariables.clear();
  }
  processTokens(tokens);
  return {
    apply: processTokens,
    update: updateTokens,
    remove: removeTokens,
    getAppliedVariables: () => [...appliedVariables]
  };
};
export {
  createTokens
};
//# sourceMappingURL=tokens.js.map
